import { createContext } from 'react';

import { IFeatureContext, IFeaturesState } from './interfaces';

export const DEFAULT_STATE: IFeaturesState = {
  features: [],
  host_count: 0,
  subscription: null,
  expiresAt: null,
  isFeaturesInitialized: false,
  it_adviser_support: false,
  shortcuts_sync_enabled: false,
  company_owner: null,
  verification: {
    status: null,
  },
};

export const FeaturesContext = createContext<IFeatureContext>({
  ...DEFAULT_STATE,
  loadFlags: () => Promise.reject(),
  clearFeatures: () => null,
});
